import Icon from './icon';

export default class Nav {
	public readonly breakpoint: number = 900;
	public readonly shade: HTMLDivElement = document.createElement('div');
	private readonly container: HTMLDivElement = document.querySelector('#outer-container > header > .content') as HTMLDivElement;
	private readonly button: HTMLButtonElement = document.createElement('button');
	private _isOpen: boolean = false;

	constructor() {
		this.button.classList.add('mobile-nav-toggle');
		this.button.type = 'button';
		this.button.addEventListener('click', () => this.toggle());
		this.button.append(Icon.create('bars'));

		this.shade.addEventListener('click', () => this.toggle(false));
		this.shade.id = 'navigation-shade';
		
		this.container.append(this.button);
		document.body.append(this.shade);

		window.addEventListener('resize', () => {
			if (window.innerWidth >= this.breakpoint) this.toggle(false);
		});
	}

	public toggle(isOpen?: boolean): void {
		this.isOpen = isOpen === undefined ? !this.isOpen : isOpen;
	}

	public set isOpen(isOpen: boolean) {
		this._isOpen = isOpen;
		document.body.classList.toggle('mobile-nav-open', this.isOpen);
	}

	public get isOpen(): boolean {
		return this._isOpen;
	}
}
